const info = {
  home: {
    'headerVideo': {
      "ERTIGA": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/video/2022/ertiga.mp4",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2022/preview-ertiga.png",
      },
      "ERTIGA BOOSTERGREEN": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/video/2023/ertiga-boostergreen.mp4",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2023/preview-ertiga-boostergreen.png",
      },
      "ERTIGA XL7": {
        video: "https://cdn.marciano.space/suzuki/videos/ertiga-xl7.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-ertiga-xl7.jpg",
      },
      "ERTIGA XL7 BOOSTERGREEN": {
        video: "",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-ertiga-xl7-boostergreen.jpg",
      },
      "JiMNY": {
        video: "",
        image: "http://drive.google.com/uc?export=view&id=18tiKPRkS3gCYPnKXYzCNqWPXAC5F7bRK",
      },
      "BALENO": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/video/2023/baleno.mp4",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2022/preview-baleno.png",
      },
      "SWIFT BOOSTERGREEN": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/video/2022/swift-booster-green.mp4?v=2",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2022/preview-swift-booster-green.png",
      },
      "SWIFT": {
        video: "https://cdn.marciano.space/suzuki/videos/swift.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-swift.jpg",
      },
      "IGNIS": {
        video: "https://cdn.marciano.space/suzuki/videos/ignis.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-ignis.jpg",
      },
      "SWIFT-SPORT": {
        video: "https://cdn.marciano.space/suzuki/videos/swift-sport.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-swift-sport.jpg",
      },
      'VITARA': {
        video: "https://cdn.marciano.space/suzuki/videos/vitara.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-vitara.jpg",
      },
      "S-CROSS": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/video/2023/s-cross.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-s-cross.jpg",
      },
      'CIAZ': {
        video: "https://cdn.marciano.space/suzuki/videos/ciaz.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-ciaz.jpg",
      },
      'CIAZ 2021': {
        video: "https://cdn.marciano.space/suzuki/videos/ciaz.mp4",
        image: "https://cdn.marciano.space/suzuki/banners/preview-ciaz.jpg",
      },
      "GRAND VITARA BOOSTERGREEN": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-grand-vitara-boostergreen.jpg",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-grand-vitara-boostergreen.jpg",
      },
      "FRONX BOOSTERGREEN": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-fronx-boostergreen.jpg",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-fronx-boostergreen.jpg",
      },
      "JIMNY": {
        video: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-jimny.jpg",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2024/preview-jimny.jpg",
      },
      "NUEVO SWIFT BOOSTERGREEN": {
        video: "",
        image: "https://cdn.marciano.space/suzuki/web-site-api/assets/banners/2025/preview-swift-boostergreen.jpg?v=2",
      },
    },
    headerSlider: [
      {
        name: "ERTIGA XL7 BOOSTERGREEN",
        titleImage: "ertiga-xl7-boostergreen.svg",
        titleImageF: "ertiga-xl7-boostergreen-tittle.svg",
        seguroAuto: 18399.60,
        contadoIVA: 10257.07,
        constIVA: 127.89,
        financiadoIVA: 511.55,
        image: "ertiga-xl7-boostergreen.png",
        title: "",
        price: "459,990.00",
        priceTotal: "$459,990.00",
        mensualidad: "4,499",
        payments: "",
        mensualidadDesde:'Mensualidades Desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/ErtigaXL7Boostergreen",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/v2/suzuki-ficha-tecnica-ertiga-xl7-boostergreen.pdf?v=1",
                colores: [
                  { name: "Arena Onix", color: "#d5cec3", color2: "#000001", image: "ERTIGA-XL7-BOOSTERGREEN/ERTIGA-BOOSTERGREEN-Models/ertiga-xl7-boostergreen-glx-arena-onix.png" },
                  { name: "Blanco Estelar", color: "#fff", color2: "#000001", image: "ERTIGA-XL7-BOOSTERGREEN/ERTIGA-BOOSTERGREEN-Models/ertiga-xl7-boostergreen-glx-blanco-estelar.png" },
                  { name: "Gris Magma", color: "#515151", image: "ERTIGA-XL7-BOOSTERGREEN/ERTIGA-BOOSTERGREEN-Models/ertiga-xl7-boostergreen-glx-gris-magma.png" },
                  { name: "Negro Cosmos", color: "#2e2e2e", image: "ERTIGA-XL7-BOOSTERGREEN/ERTIGA-BOOSTERGREEN-Models/ertiga-xl7-boostergreen-glx-negro-cosmos.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 459990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TA de 17.7 Km/lt",
                  'Transmisión Automática de 4 Velocidades',
                  "Pantalla de 7” Touch Screen con sistema Bluetooth®, vínculo con Smartphones (Apple CarPlay®* y Android Auto™**) y cámara de reversa",
                  "Faros con tecnología LED y conjunto de luces diurnas LED con encendido Automático",
                  "Control de velocidad crucero en el volante",
                  "Tomacorriente de 12 Volts para consola central, segunda y tercer fila",
                  "Motor con tecnología BOOSTERGREEN 1.5 Lt DOHC VVT, Potencia 103 hp@6,000 rpm Torque 102 lb/ft@4,400 rpm",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "FRONX BOOSTERGREEN",
        titleImage: "fronx-boostergreen.svg",
        titleImageF: "fronx-boostergreen-tittle.svg",
        seguroAuto: 17639.60,
        contadoIVA: 10257.07,
        constIVA: 127.89,
        financiadoIVA: 511.55,
        image: "fronx-boostergreen.png",
        title: "Diversidad sin limites",
        price: "449,990.00",
        priceTotal: "$449,990.00",
        mensualidad: "4,599",
        payments: "",
        mensualidadDesde:'Mensualidades Desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/FRONXBOOSTERGREENGLX",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-fronx-boostergreen.pdf?v=1",
                colores: [
                  { name: "Blanco Invierno", color: "#f0f0f0", image: "FRONXBOOSTERGREENGLX/fronxModels/fronx-ta-blanco-invierno.png" },
                  { name: "Imperial Grey", color: "#535350", image: "FRONXBOOSTERGREENGLX/fronxModels/fronx-ta-imperial-gray.png" },
                  { name: "Raccoon", color: "#bcbcbc", color2: "#000001", image: "FRONXBOOSTERGREENGLX/fronxModels/fronx-ta-racoon.png" },
                  { name: "Fox", color: "#DE5B32",color2: "#000001", image: "FRONXBOOSTERGREENGLX/fronxModels/fronx-ta-fox.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 449990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TA de 20.9 km/lt",
                  'Motor con tecnología BoosterGreen 1.5 Lt DOHC DUALJET',
                  "Diseño dinámico y de CROSSOVER con tecnología All Day Vision",
                  "Pantalla 9” a color touch screen vínculo con smartphones inalámbrico",
                  "Pantalla 9” a color touch screen vínculo con smartphones inalámbrico",
                  "Dispositivos de advertencia acústica traseros",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "GRAND VITARA BOOSTERGREEN",
        titleImage: "grand-vitra-namebanner.svg",
        titleImageF: "grand-vitara-boostergreenForm.svg",
        seguroAuto: 19999.60,
        contadoIVA: 11625.87,
        constIVA: 156.6,
        financiadoIVA: 579.99,
        image: "grand-vitara-boostergreen.png",
        title: "Reborn",
        price: "504,990.00",
        priceTotal: "$504,990.00",
        mensualidad: "5,649",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/GrandVitra",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-grand-vitara-boostergreen.pdf?v=1",
                colores: [
                  { name: "Imperial Grey", color: "#565757", image: "vitara/vitaraModels/grand-vitara-imperial-grey.png" },
                  { name: "Deep Blue", color: "#295DAB", image: "vitara/vitaraModels/grand-vitara-deep-blue.png" },
                  { name: "Novel White", color: "#F8F9F9", color2: "#000001", image: "vitara/vitaraModels/grand-vitara-novel-white.png" },
                  { name: "Silver Grafito", color: "#C8C7C7", color2: "#000001", image: "vitara/vitaraModels/grand-vitara-silver-grafito.png" },
                  { name: "Dark Carmine", color: "#BC2C2B",color2: "#000001", image: "vitara/vitaraModels/grand-vitara-dark-carmine.png" },
                  
                ],
                transmisiones: [
                  { name: "Automático", price: 504990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TA de 19.8 km/lt",
                  '1.5 Lt DOHC DUALJET',
                  "Transmisión automática de 6 velocidades",
                  "Pantalla 9” a color touch screen vínculo con smartphones inalámbrico",
                  "Motor con tecnología BoosterGreen",
                  "Diseño de luces Flat Light Design con proyección LED",
                  "Portaequipaje con capacidad de 310 lts. expandibles a 1,147 lts.",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "ERTIGA BOOSTERGREEN",
        titleImage: "ertiga-booster-green.svg",
        titleImageF: "ertiga-booster-greenForm.svg",
        seguroAuto: 15199.60,
        contadoIVA: 8841.87,
        constIVA: 111.65,
        financiadoIVA: 440.79,
        image: "ertiga-boostergreen.png",
        title: "Mayor rendimiento",
        price: "385,990.00",
        mensualidad: "4,499",
        priceTotal: "$385,990.00",
        payments: "72 mensualidades y enganche de 50%",
        mensualidadDesde:'Mensualidades desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/ErtigaBoostergreen",
        pathName: "ErtigaBoostergreen",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLS",
                colores: [
                  { name: "Plata Metálico", color: "#848484", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-gls-plata-metalico.png" },
                  { name: "Blanco Perlado", color: "#F5F5F5", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-gls-blanco-perlado.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 385990.00 },
                  { name: "Automático", price: 404990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TM5 de 17 km/lt y TA4 de 18.3 km/lt",
                  "Motor 4 cilindros 1.5 lt, DOHC VVT y 16 válvulas",
                  "2 bolsas de aire frontal",
                  "Motor generador eléctrico.Potencia máxima: 3 Hp Torque máximo: 36 lb/ft Conjunto de batería ion-litio",
                  "Transmisión manual de 5 velocidades y automática de 4 velocidades.",
                  "Sistema de infoentretenimiento de 7”",
                  "Aire acondicionado manual con salidas de aire para la primera y segunda fila",
                  "Doble fondo en cajuela con capacidad del área de carga de hasta 803 lts con asientos abatidos",
                  "Nuevo diseño de parrilla"
                ]
              },
              {
                version: "GLX",
                colores: [
                  { name: "Gris Magma", color: "#746b62", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-glx-gris-magma.png" },
                  { name: "Plata Metálico", color: "#848484", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-glx-plata-metalico.png" },
                  { name: "Blanco Perlado", color: "#f5f5f5", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-glx-blanco-perlado.png" },
                  { name: "Rojo Escarlata", color: "#8b2023", image: "ertiga-boostergreen/ErtigaBoostergrenModels/ertiga-boostergreen-glx-rojo-escarlata.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 417990.00 },
                  { name: "Automático", price: 437990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TM5 de 17 km/lt y TA4 de 18.3 km/lt",
                  "Motor 4 cilindros 1.5 lt, DOHC VVT y 16 válvulas",
                  "Motor generador eléctrico.Potencia máxima: 3 Hp Torque máximo: 36 lb/ft Conjunto de batería ion-litio",
                  "Transmisión manual de 5 velocidades y automática de 4 velocidades",
                  "Sistema de infoentretenimiento de 7”",
                  'Aire acondicionado automático con salidas de aire para la segunda fila y portavasos ventilado en la primer fila',
                  'Nuevo clúster central a color de 4.2"',
                  "Doble fondo en cajuela con capacidad del área de carga de hasta 803 lts con asientos abatidos",
                  "Nuevo diseño de parrilla",
                  "Control Crucero"
                ]
              },
            ]
          },
        ]
      },
    /** 
      {
        name: "ERTIGA XL7",
        titleImage: "ertiga-xl7.svg",
        titleImageF: "ertiga-xl7Form.svg",
        seguroAuto: 16919.60,
        contadoIVA: 9839.47,
        constIVA: 122.67,
        financiadoIVA: 490.67,
        image: "ertiga-xl7.png",
        title: "Para tu mejor versión",
        price: "422,990.00",
        mensualidad: "3,999",
        priceTotal: "$422,990.00",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/ertiga",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2023/v2/suzuki-ficha-tecnica-ertiga-xl7.pdf",
                colores: [
                  { name: "Naranja Sideral", color: "#ED5446", color2: "#000000" , image: "ERTIGAXL7/ErtigaModels/ertiga-xl7-naranja-sideral.png" },
                  { name: "Gris Magma", color: "#857469", image: "ERTIGAXL7/ErtigaModels/ertiga-xl7-gris-magma.png" },
                  { name: "Blanco Estelar", color: "#FFFFFF", color2: "#000000", image: "ERTIGAXL7/ErtigaModels/ertiga-xl7-blanco-estelar.png" },
                  { name: "Negro Cosmos", color: "#2E2E2E", image: "ERTIGAXL7/ErtigaModels/ertiga-xl7-negro-cosmos.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 422990.00 }
                ],
                details: [
                  "Motor 4 cilindros 1.5 lt, 16 válvulas DOHC / VVT, Potencia 103 hp @ 6,000 RPM, Torque 102 lb-ft @ 4,400 RPM",
                  'Pantalla a color 7" Touch Screen con sistema Bluetooth@, vínculo con Smartphones (Apple CarPlay@ y Android AutoTM**)',
                  "Trasmisión automática de 4 velocidades",
                  "Rendimiento de combustible combinado en TA de 17.4 km/lt",
                  "Bocinas en puertas delanteras y traseras X2. Tweeters frontales X2.",
                  "Sensores de reversa y luces traseras LED",
                  "Nueva tecnología de faros LED. Faros de niebla",
                ]
              },
            ]
          },
        ]
      }, */
      {
        name: "SWIFT",
        titleImage: "swift.svg",
        titleImageF: "swiftForm.svg",
        seguroAuto: 11999.60,
        contadoIVA: 6985.87,
        constIVA: 87,
        financiadoIVA: 347.99,
        image: "SWIFT-2021.png",
        title: "Renovado y divertido",
        price: "324,990",
        priceTotal: "$324,990.00",
        mensualidad: "3,499",
        payments: "Mensualidades desde",
        mensualidadDesde: 'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/swift",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLS",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-swift-gls-glx.pdf",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-gls-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-gls-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-gls-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-gls-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 324990.00 },
                  { name: "CVT", price: 339990.00 }
                ],
                details: [
                  "Rendimiento de combustible en CVT de 22.6 km/lt",
                  "Control Electrónico de Estabilidad ESP ",
                  "2 bolsas de aire frontal",
                  "Motor 4 cilindros 1.2 lt, DOHC, 16 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión CVT",
                  "Reproductor de CD compatible con MP3 / WMA + Bluetooth®.",
                ]
              },
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-swift-gls-glx.pdf",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-glx-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-glx-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-glx-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-glx-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 339990.00 },
                  { name: "CVT", price: 359990.00 }
                ],
                details: [
                  "Rendimiento de combustible en CVT de 22.6 km/lt",
                  "Control Electrónico de Estabilidad ESP",
                  "6 bolsas de aire: 2 bolsas de aire frontales, 2 bolsas de aire laterales y 2 bolsas de aire tipo cortina.",
                  "Motor 4 cilindros 1.2 lt, DOHC, 16 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión CVT",
                  'Pantalla touch de 7" con integración + Bluetooth® + Navegador',
                  "Faros y luces diurnas de LED",
                  "Manos libres al volante y control crucero",
                  "Cámara de reversa con sensores de estacionamiento",
                ]
              },
              {
                version: "BOOSTERJET",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-swift-boosterjet-glx.pdf",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-glx-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-glx-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-glx-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-glx-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 359990.00 },
                  { name: "Automático", price: 379990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TA Boosterjet de 22 km/lt",
                  "Control Electrónico de Estabilidad ESP",
                  "6 bolsas de aire: 2 bolsas de aire frontales, 2 bolsas de aire laterales y 2 bolsas de aire tipo cortina.",
                  "Motor 3 cilindros 1.0 lt, DOHC, 12 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión automática de 6 velocidades",
                  'Pantalla touch de 7" con integración + Bluetooth® + Navegador',
                  "Faros y luces diurnas de LED",
                  "Manos libres al volante y control crucero",
                  "Motor Boosterjet",
                  "Cámara de reversa con sensores de estacionamiento",
                ]
              },
            ]
          },
          /*{
            año: "2023",
            versiones: [
              {
                version: "GLS",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2023/v3/suzuki-ficha-tecnica-swift.pdf?v=2",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-gls-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-gls-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-gls-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-gls-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 299990.00 },
                  { name: "CVT", price: 324990.00 }
                ],
                details: [
                  "Rendimiento de combustible en CVT de 22.6 km/lt",
                  "Control Electrónico de Estabilidad ESP ",
                  "2 bolsas de aire frontal",
                  "Motor 4 cilindros 1.2 lt, DOHC, 16 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión CVT",
                  "Reproductor de CD compatible con MP3 / WMA + Bluetooth®.",
                ]
              },
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2023/v3/suzuki-ficha-tecnica-swift.pdf?v=2",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-glx-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-glx-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-glx-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-glx-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 344990.00 },
                  { name: "CVT", price: 364990.00 }
                ],
                details: [
                  "Rendimiento de combustible en CVT de 22.6 km/lt",
                  "Control Electrónico de Estabilidad ESP",
                  "6 bolsas de aire: 2 bolsas de aire frontales, 2 bolsas de aire laterales y 2 bolsas de aire tipo cortina.",
                  "Motor 4 cilindros 1.2 lt, DOHC, 16 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión CVT",
                  'Pantalla touch de 7" con integración + Bluetooth® + Navegador',
                  "Faros y luces diurnas de LED",
                  "Manos libres al volante y control crucero",
                  "Cámara de reversa con sensores de estacionamiento",
                ]
              },
              {
                version: "BOOSTERJET",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2023/v3/suzuki-ficha-tecnica-swift.pdf?v=2",
                colores: [
                  { name: "Rojo Vanadio", color: "#c41e3a", image: "Swift2021/SwiftModels/swift-glx-rojo-vanadio.png" },
                  { name: "Plata Sílice", color: "#c1c1c1", image: "Swift2021/SwiftModels/swift-glx-plata-silice.png" },
                  { name: "Gris Acero", color: "#6e6e6e", image: "Swift2021/SwiftModels/swift-glx-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "Swift2021/SwiftModels/swift-glx-blanco-pop.png" }
                ],
                transmisiones: [
                  { name: "Manual", price: 364990.00 },
                  { name: "Automático", price: 384990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TA Boosterjet de 22 km/lt",
                  "Control Electrónico de Estabilidad ESP",
                  "6 bolsas de aire: 2 bolsas de aire frontales, 2 bolsas de aire laterales y 2 bolsas de aire tipo cortina.",
                  "Motor 3 cilindros 1.0 lt, DOHC, 12 válvulas",
                  "Transmisión manual de 5 velocidades o transmisión automática de 6 velocidades",
                  'Pantalla touch de 7" con integración + Bluetooth® + Navegador',
                  "Faros y luces diurnas de LED",
                  "Manos libres al volante y control crucero",
                  "Motor Boosterjet",
                  "Cámara de reversa con sensores de estacionamiento",
                ]
              },
            ]
          }*/
        ]
      },
      {
        name: "IGNIS",
        titleImage: "ignis-banner.svg",
        titleImageF: "ignisForm.svg",
        seguroAuto: 9999.60,
        contadoIVA: 5825.87,
        constIVA: 84.1,
        financiadoIVA: 289.99,
        image: "ignis2024.png",
        title: "Mayor rendimiento",
        price: "254,990",
        priceTotal: "$254,990.00",
        mensualidad: "3,499",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/ignis",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GL",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-ignis.pdf?v=3",
                colores: [
                  { name: "Gris Acero", color: "#434C4F", image: "IGNIS2021/ignisModels/ignis-gls-plus-gris-acero.png" },
                  { name: "Blanco Pop", color: "#FCFBFC", image: "IGNIS2021/ignisModels/ignis-gls-plus-blanco-pop.png" },
                  { name: "Rojo Vanadio", color: "#C42826", image: "IGNIS2021/ignisModels/ignis-gls-plus-rojo-vanadio.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 254990.00 },
                  { name: "CVT", price: 284990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en Manual de 21.7 km/lt y en CVT de 21.9 km/lt",
                  'Motor 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, Potencia 82 hp @ 6,000 RPM, Torque 83 lb/ft @ 4,200 RPM',
                  "Transmisión manual de 5 velocidades o CVT",
                  "Bocinas frontales X2",
                  "Aire Acondicionado manual",
                ]
              },
              {
                version: "GLS-Z",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-ignis.pdf?v=3",
                colores: [
                  { name: "Gris Acero", color: "#434C4F", image: "IGNIS2021/ignisModels/ignis-gls-plus-gris-acero.png" },
                  { name: "Blanco Pop", color: "#FCFBFC", image: "IGNIS2021/ignisModels/ignis-gls-plus-blanco-pop.png" },
                  { name: "Rojo Vanadio", color: "#C42826", image: "IGNIS2021/ignisModels/ignis-gls-plus-rojo-vanadio.png" },
                  { name: "Azul Sodalita", color: "#295DAB", image: "IGNIS2021/ignisModels/ignis-gls-plus-azul-sodalita.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 289990.00 },
                  { name: "CVT", price: 309990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en Manual de 21.7 km/lt y en CVT de 21.9 km/lt",
                  'Motor 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, Potencia 82 hp @ 6,000 RPM, Torque 83 lb/ft @ 4,200 RPM',
                  "Transmisión manual de 5 velocidades o CVT",
                  "Pantalla touch screen a color con sistema Bluetooth vínculo con smartphones.",
                  "Bocinas frontales X2",
                  "Aire Acondicionado manual",
                ]
              },
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-ignis.pdf?v=3",
                colores: [
                  { name: "Gris Acero", color: "#434C4F", image: "IGNIS2021/ignisModels/ignis-glx-gris-acero.png" },
                  { name: "Azul Sodalita", color: "#295DAB", image: "IGNIS2021/ignisModels/ignis-glx-azul-sodalita.png" },
                  { name: "Duna", color: "#DAD3CA", image: "IGNIS2021/ignisModels/ignis-glx-duna.png" },
                  { name: "Rojo Vulcano", color: "#E8003B", color2:"#000001", image: "IGNIS2021/ignisModels/ignis-glx-rojo-vulcano.png" },
                  { name: "Constelación", color: "#FCFBFC", color2:"#000001", image: "IGNIS2021/ignisModels/ignis-glx-constelacion.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 319990.00 },
                  { name: "CVT", price: 339990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en Manual de 21.7 km/lt y en CVT de 21.9 km/lt",
                  'Motor 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, Potencia 82 hp @ 6,000 RPM, Torque 83 lb/ft @ 4,200 RPM',
                  "Transmisión manual de 5 velocidades o CVT",
                  "Pantalla a color 7” Touch Screen con sistema Bluetooth®, vínculo con Smartphones (Apple CarPlay®* y Android Auto™**) y cámara de reversa.",
                  "Bocinas frontales, traseras y tweeters (X2)",
                  "Faros con proyección elipsoidal LED. Luz diurna incorporada",
                  "Control de velocidad crucero en el volante",
                  "Aire Acondicionado automático que no compromete la potencia ni el rendimiento de gasolina.",
                  "Volante forrado en piel"
                ]
              },
            ]
          },
          /*{
            año: "2023",
            versiones: [
              {
                version: "GLX",
                colores: [
                  { name: "Constelación", color: "#E1E7E9", color2:"#000001", image: "IGNIS2021/ignisModels/ignis-glx-constelacion.png" },
                  { name: "Fenix", color: "#E8003B", color2:"#000001", image: "IGNIS2021/ignisModels/IGNIS-GLX-FENIX.png" },
                  { name: "Mentolato", color: "#4699A9", color2:"#000001", image: "IGNIS2021/ignisModels/IGNIS-GLX-MENTOLATO.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 319990.00 },
                  { name: "CVT", price: 339990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en Manual de 21.7 km/lt y en CVT de 21.9 km/lt",
                  'Motor 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, Potencia 82 hp @ 6,000 RPM, Torque 83 lb/ft @ 4,200 RPM',
                  "Transmisión manual de 5 velocidades o CVT",
                  "Pantalla a color 7” Touch Screen con sistema Bluetooth®, vínculo con Smartphones (Apple CarPlay®* y Android Auto™**) y cámara de reversa.",
                  "Bocinas frontales, traseras y tweeters (X2)",
                  "Faros con proyección elipsoidal LED. Luz diurna incorporada",
                  "Control de velocidad crucero en el volante",
                  "Aire Acondicionado automático que no compromete la potencia ni el rendimiento de gasolina.",
                  "Volante forrado en piel"
                ]
              },
              {
                version: "GLS+",
                colores: [
                  { name: "Blanco Pop", color: "#FCFBFC",  image: "IGNIS2021/ignisModels/ignis-gls-plus-blanco-pop.png" },
                  { name: "Gris Acero", color: "#434CAF", image: "IGNIS2021/ignisModels/ignis-gls-plus-gris-acero.png" },
                  { name: "Rojo", color: "#E8003B", image: "IGNIS2021/ignisModels/ignis-gls-plus-rojo.png" },
                  { name: "Agua Marina", color: "#2DA0A0", image: "IGNIS2021/ignisModels/ignis-gls-plus-agua-marina.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 289990.00 },
                  { name: "CVT", price: 309990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en Manual de 21.7 km/lt y en CVT de 21.9 km/lt",
                  'Motor 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, Potencia 82 hp @ 6,000 RPM, Torque 83 lb/ft @ 4,200 RPM',
                  "Transmisión manual de 5 velocidades o CVT",
                  "Pantalla touch 7” a color touch screen con sistema Bluetooth vínculo con smartphones.",
                  "Bocinas frontales X2",
                  "Aire Acondicionado manual",
                ]
              },
            ]
          },*/
        ]
      },
      {
        name: "SWIFT-SPORT",
        titleImage: "swift-sport-banner.svg",
        titleImageF: "swift-sportForm.svg",
        seguroAuto: 16039.60,
        contadoIVA: 9329.07,
        constIVA: 114.55,
        financiadoIVA: 465.15,
        image: "swift-sport.png",
        title: "Mayor rendimiento",
        price: "397,990.00",
        priceTotal: "$397,990.00",
        mensualidad: "3,499",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/swift-sport",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-swift-sport.pdf",
                colores: [
                  { name: "Negro Supremo", color: "#000000", image: "swift-sport/swiftsportModels/swift-sport-negro-supremo.png" },
                  { name: "Amarillo Rally", color: "#eed71c", image: "swift-sport/swiftsportModels/swift-sport-amarillo-rally.png" },
                  { name: "Blanco Pop", color: "#FFFFFF", image: "swift-sport/swiftsportModels/swift-sport-blanco-pop.png" },
                  { name: "Rojo Vanadio", color: "#b40404", image: "swift-sport/swiftsportModels/swift-sport-rojo-vanadio.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 397990.00 },
                  { name: "Automático", price: 425990.00 }
                ],
                details: [
                  "6 bolsas de aire: 2 bolsas de aire frontales, 2 bolsas de aire laterales y 2 bolsas de aire tipo cortina.",
                  'Transmisión manual o automática de 6 velocidades',
                  "Pantalla touch a color con sistema Bluetooth®, vínculo con Smartphones Apple CarPlayTM y Android AutoTM.",
                  "Luz de tránsito diurno DRL. Luz de niebla",
                  "Espejos plegables electrónicamente con luz direccional integrada",
                  "Doble escape cromado",
                  "Cluster a color con gráfica (disponible en las dos transmisiones) y sensor de estacionamiento trasero (disponible en TA)",
                  "Sensor de estacionamiento trasero (disponible en TA) y cámara de reversa (disponible en las dos transmisiones).",
                  "Sensores de estacionamiento traseros exclusivos para Transmisión Automática",
                  "Distribución electrónica de frenado (EBD)",
                  "Rendimiento de combustible en TA Boosterjet de 18.7 km/lt",
                  "Motor 4 cilindros, 1.4 lt, Boosterjet",
                  "Control electrónico de estabilidad ESC",
                  "Frenos de disco delanteros y traseros."
                ]
              },
            ]
          },
        ]
      },
      {
        name: "S-CROSS",
        titleImage: "s-cross-banner.svg",
        titleImageF: "s-crossForm.svg",
        seguroAuto: 21199.60,
        contadoIVA: 12321.87,
        constIVA: 160.95,
        financiadoIVA: 614.79,
        image: "s-cross.png",
        title: "Redefiniendo la Aventura",
        price: "484,990.00",
        priceTotal: "$484,990.00",
        mensualidad: "4,899",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/s-cross",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "BOOSTERJET GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-s-cross.pdf",
                colores: [
                  { name: "Blanco Iridio", color: "#F4F4F4", image: "s-cross/scrossModels/s-cross-blanco-iridio.png" },
                  { name: "Azul Zafiro", color: "#242D43", image: "s-cross/scrossModels/s-cross-azul-zafiro.png" },
                  { name: "Gris Ágata", color: "#4C4C4C",  image: "s-cross/scrossModels/s-cross-gris-agata.png" },
                  { name: "Negro", color: "#000000", image: "s-cross/scrossModels/scross-glx-negro.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 484990.00 }
                ],
                details: [
                  "Rendimiento de combustible en TA de 18.0 km/lt",
                  'Motor 4 cilindros 1.4 lt, DOHC Boosterjet',
                  "Transmisión automática de 6 velocidades con paletas de cambios al volante.",
                  "Pantalla a color touch de 9”compatible con Android Auto y Apple Car Play, Bluetooth®, cámara de reversa 360° y sensores de estacionamiento delantero y trasero.",
                  "Sistema de aire acondicionado automático de doble zona.",
                  "Techo panorámico con doble cristal corredizo.",
                  "Distribución electrónica de frenado (EBD)",
                  "Luz de tránsito diurno DRL",
                  "Luz de niebla",
                  "Anclajes de sistemas de retención infantil (ISOFIX)"
                ]
              },
            ]
          },
        ]
      },
      {
        name: "BALENO",
        titleImage: "baleno-banner.svg",
        titleImageF: "balenoForm.svg",
        seguroAuto: 13599.60,
        contadoIVA: 7913.87,
        constIVA: 101.5,
        financiadoIVA: 394.39,
        image: "baleno.png",
        title: "El nuevo Baleno completamente renovado",
        price: "339,990.00",
        priceTotal: "$339,990.00",
        mensualidad: "4,499",
        payments: "Mensualidades desde",
        mensualidadDesde:'Mensualidad desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/baleno",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLS",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-baleno.pdf",
                colores: [
                  { name: "Deep Blue", color: "#265485", image: "baleno/balenoModels/baleno-gls-deep-blue.png" },
                  { name: "Sonic Silver", color: "#aab7c3", image: "baleno/balenoModels/baleno-gls-sonic-silver.png" },
                  { name: "Prime White", color: "#FFFFFF", image: "baleno/balenoModels/baleno-gls-prime-white.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 339990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TA de 20.5 km/lt",
                  'Motor 4 cilindros 1.5 lt, DOHC WT y 16 válvulas',
                  "Transmisión automática de 4 velocidades.",
                  "Pantalla de audio de 7 pulgadas + Bluetooth®*.",
                  "Aire acondicionado automático con salidas de aire para la segunda fila y descansa brazos central.",
                  "Faros de proyección de halógeno y luz de niebla.",
                ]
              },
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-baleno.pdf",
                colores: [
                  { name: "Deep Blue", color: "#265485", image: "baleno/balenoModels/baleno-glx-deep-blue.png" },
                  { name: "Sonic Silver", color: "#aab7c3", image: "baleno/balenoModels/baleno-glx-sonic-silver.png" },
                  { name: "Prime White", color: "#FFFFFF", image: "baleno/balenoModels/baleno-glx-prime-white.png" },
                  { name: "Midnight Black", color: "#2E2E2E", image: "baleno/balenoModels/baleno-glx-midnight-black.png" },
                ],
                transmisiones: [
                  { name: "Automático", price: 385990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TA de 20.5 km/lt",
                  'Motor 4 cilindros 1.5 lt, DOHC WT y 16 válvulas',
                  "Transmisión automática de 4 velocidades.",
                  "Pantalla de 9” conectividad Android Auto y Apple Carplay",
                  "Aire acondicionado automático con salidas de aire para la segunda fila y descansa brazos central deslizable.",
                  "Faros de proyección con tecnología LED, Luz de transito diurno DRL y Luz de niebla.",
                  "Nuevo diseño de parrilla con inserto cromado. Molduras y manijas cromadas en puertas.",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "JIMNY",
        titleImage: "Jimny.png",
        titleImageF: "jimnyForm.svg",
        seguroAuto: 18239.60,
        contadoIVA: 10605.07,
        constIVA: 129.34,
        financiadoIVA: 528.95,
        image: "JIMNY.6f3c5732.png",
        title: "La leyenda llegó a México",
        price: "460,990.00",
        priceTotal: "$460,990.00",
        mensualidad: "460,990",
        payments: "",
        mensualidadDesde:'Desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/jimny",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-jimny.pdf?v=1",
                colores: [
                  { name: "Blanco Polar", color: "#ffffff", image: "Jimny/jimnyModels/jimny-glx-blanco.png" },
                  { name: "Gris Cuarzo", color: "#787878", image: "Jimny/jimnyModels/jimny-glx-gris.png" },
                  { name: "Negro Carbón", color: "#000000", image: "Jimny/jimnyModels/jimny-glx-negro.png" },
                  { name: "Verde Obsesión", color: "#adf932", image: "Jimny/jimnyModels/jimny-glx-verde-obsesion.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 460990.00 },
                  { name: "Automático", price: 485990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TM de 15.4 km/lt",
                  '1.5 Lt DOHC VVT y 16 válvulas',
                  "Transmisión Manual de 5 velocidades y Transmisión automática de 4 velocidades",
                  "Tracción (4WD) ALL GRIP PRO",
                  "Pantalla 7” a color touch screen vínculo con smartphones (Apple CarPlay y Android Auto TM).",
                  "Sistema de tracción con caja reductora y tres modos de manejo, para condiciones de Off Road.",
                  "3 modos de conducción para afrontar cualquier tipo de terreno gracias al sistema All Grip Pro.",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "JIMNY 5 DOOR",
        titleImage: "jimny-5-door-rojo.png",
        titleImageF: "jimnyForm.svg",
        seguroAuto: 18239.60,
        contadoIVA: 10605.07,
        constIVA: 129.34,
        financiadoIVA: 528.95,
        image: "jimny-5-door-rojo.png",
        title: "La leyenda llegó a México",
        price: "522,990.00",
        priceTotal: "$522,990.00",
        mensualidad: "522,990",
        payments: "",
        mensualidadDesde:'Desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/JIMNY5DOOR",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-jimny.pdf?v=1",
                colores: [
                  { name: "Blanco Polar", color: "#ffffff", image: "Jimny/jimnyModels/jimny-glx-blanco.png" },
                  { name: "Gris Cuarzo", color: "#787878", image: "Jimny/jimnyModels/jimny-glx-gris.png" },
                  { name: "Negro Carbón", color: "#000000", image: "Jimny/jimnyModels/jimny-glx-negro.png" },
                  { name: "Verde Obsesión", color: "#adf932", image: "Jimny/jimnyModels/jimny-glx-verde-obsesion.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 460990.00 },
                  { name: "Automático", price: 485990.00 }
                ],
                details: [
                  "Rendimiento de combustible combinado en TM de 15.4 km/lt",
                  '1.5 Lt DOHC VVT y 16 válvulas',
                  "Transmisión Manual de 5 velocidades y Transmisión automática de 4 velocidades",
                  "Tracción (4WD) ALL GRIP PRO",
                  "Pantalla 7” a color touch screen vínculo con smartphones (Apple CarPlay y Android Auto TM).",
                  "Sistema de tracción con caja reductora y tres modos de manejo, para condiciones de Off Road.",
                  "3 modos de conducción para afrontar cualquier tipo de terreno gracias al sistema All Grip Pro.",
                ]
              },
            ]
          },
        ]
      },
     /* {
        name: "SWIFT BOOSTERGREEN",
        titleImage: "swift-boostergreen-banner.svg",
        titleImageF: "swift-boostergreenForm.svg",
        seguroAuto: 13599.60,
        contadoIVA: 7913.87,
        constIVA: 105.85,
        financiadoIVA: 394.39,
        image: "swift-booster-green.png",
        title: "Ser conscientes ahora es más divertido",
        price: "339,990.00",
        priceTotal: "$339,990.00",
        mensualidad: "3,499",
        payments: "72 mensualidades y enganche de 56%",
        mensualidadDesde:'Mensualidades desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/SwiftBoostergreen",
        detallesInfo: [
          {
            año: "2024",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2024/suzuki-ficha-tecnica-swift-boostergreen.pdf",
                colores: [
                  { name: "Amarillo Ocaso", color: "#FED500", color2: "#8B8C8E" , image: "SWIFT-BOOSTERGREEN/swiftBGModels/swift-boostergreen-glx-amarillo-ocaso.png" },
                  { name: "Rojo Vulcano", color: "#E50E0D", color2: "#000001", image: "SWIFT-BOOSTERGREEN/swiftBGModels/swift-boostergreen-glx-rojo-vulcano.png" },
                  { name: "Azul Tormenta", color: "#006EA6", color2: "#000001", image: "SWIFT-BOOSTERGREEN/swiftBGModels/swift-boostergreen-glx-azul-tormenta.png" },
                  { name: "Naranja Monarca", color: "#DE4E13", color2: "#000001", image: "SWIFT-BOOSTERGREEN/swiftBGModels/swift-boostergreen-glx-naranja-monarca.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 339990.00 }
                ],
                details: [
                  "Motor DualJet naturalmente aspirado 4 cilindros 1.2 lt, 16 válvulas DOHC / VVT, 8 inyectores, Potencia 88 HP @ 6,000 RPM, Torque 88 lb/ft @ 4,400 RPM.",
                  'Transmisión Manual de 6 velocidades.',
                  "Rendimiento de combustible combinado en TM de 23.8 km/lt. ",
                  "Sistema de infoentretenimiento con pantalla touch de 7” a color. Vinculo con smartphones (Android Auto).",
                  "Luz de tránsito diurno DRL, luz de niebla.",
                  "Sistema antibloqueo para frenos (ABS), Asistente de frenado (BA) , Control electrónico de estabilidad (ESC), 6 bolsas de aire, sistemas colapsables, Anclajes de sistemas de retención infantil (ISOFIX).",
                  "A/C automático",
                  "Sistema Key-less push start"
                ]
              },
            ]
          },
        ]
      },*/
      {
        name: "CIAZ",
        titleImage: "ciaz-banner.svg",
        titleImageF: "ciazForm.svg",
        seguroAuto: 14119.60,
        contadoIVA: 8215.47,
        constIVA: 101.5,
        financiadoIVA: 409.47,
        image: "CIAZ2021.png",
        title: "Comodidad en movimiento",
        price: "352,990.00",
        priceTotal: "$352,990.00",
        mensualidad: "3,499",
        payments: "72 mensualidades y enganche de 58%",
        mensualidadDesde:'Mensualidades desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/ciaz",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLX",
                ficha: "https://cdn.marciano.space/suzuki/web-site-api/assets/datasheet/2023/v2/suzuki-ficha-tecnica-ciaz.pdf",
                colores: [
                  { name: "Blanco Horizonte", color: "#F1F1F1", image: "CIAZ2021/ciazModels/ciaz-blanco-horizonte.png" },
                  { name: "Plata Mercurio", color: "#424242", image: "CIAZ2021/ciazModels/ciaz-plata-mercurio.png" },
                  { name: "Plata Metálico", color: "#b9bfc3", image: "CIAZ2021/ciazModels/ciaz-plata-metalico.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 352990.00 },
                  { name: "Automático", price: 372990.00 }
                ],
                details: [
                  "Motor 4 cilindros, 1.4 litros y 16 válvulas, VVT en admisión.",
                  'Rendimiento combinado de combustible de 19.7 km/lt',
                  "Transmisión automática de 4 velocidades o manual de 5 velocidades",
                  'Pantalla a color Touch Screen de 7" con sistema de audio y vínculo con Smartphone, cámara y sensores de reversa, y Bluetooth®.',
                  "Faros de lupa y luces diurnas LED. Faros de niebla.",
                  "Aire acondicionado automático y tomacorriente de 12V en consola central y fila trasera. Entrada AUX y USB.",
                  "Sistema Keyless Push Start para apertura de puertas con botón de encendido.",
                ]
              },
            ]
          },
        ]
      },
      {
        name: "NUEVO SWIFT BOOSTERGREEN",
        titleImage: "swift-boostergreen-banner.svg",
        titleImageF: "swift-boostergreenForm.svg",
        seguroAuto: 12799.60,
        contadoIVA: 7423.77,
        constIVA: 92.8,
        financiadoIVA: 397.29,
        image: "nuevo-swift-boostergreen.png",
        title: "Por un mundo mejor",
        price: "334,990.00",
        priceTotal: "$334,990.00",
        mensualidad: "334,990",
        payments: "",
        mensualidadDesde:'Desde',
        video: "",
        link: "",
        quote: "",
        detallesurl: "/autos/SWiftBoostergreen2025",
        detallesInfo: [
          {
            año: "",
            versiones: [
              {
                version: "GLS",
                ficha: "",
                colores: [
                  { name: "Azul Metal", color: "#295dab", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-azul-metalico.png" },
                  { name: "Rojo Vanadio", color: "#cb253d", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/rojo.png" },
                  { name: "Plata Sílice", color: "#aeb1b4", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-plata-silice.png" },
                  { name: "Gris Acero", color: "#515151", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-blanco-pop.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 334990.00 },
                  { name: "CVT", price: 354990.00}
                ],
                details: [
                  "Rendimiento combinado de combustible en TM5 de 24.7 km/lt.",
                  'Nuevo Motor Motor Z12E.',
                  "Nuevo interior bitono.",
                  "185/55R16 + Rines de aleación.",
                  "Vidrio de privacidad (ventanas de puertas traseras + ventana de portón trasero).",
                  "Volante de 3 radios (forrado en cuero).",
                  "A/C automático.",
                  "Aire acondicionado manual con panel digital."
                ]
              },
              {
                version: "GLX",
                ficha: "",
                colores: [
                  { name: "Rojo Vanadio", color: "#cb253d", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/rojo.png" },
                  { name: "Azul Metal", color: "#295dab", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-azul-metalico.png" },
                  { name: "Plata Sílice", color: "#aeb1b4", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-plata-silice.png" },
                  { name: "Gris Acero", color: "#515151", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-gris-acero.png" },
                  { name: "Blanco Pop", color: "#f5f5f5", image: "NUEVO-SWIFT-BOOSTERGREEN/SWIFTB-MODELS/swift-bostergreen-gls-blanco-pop.png" },
                ],
                transmisiones: [
                  { name: "Manual", price: 354990.00 },
                  { name: "CVT", price: 374990.00}
                ],
                details: [
                  "Rendimiento combinado de combustible en TM5 de 24.7 km/lt.",
                  'Nuevo Motor Motor Z12E',
                  "Nuevo interior bitono",
                  "185/55R16 Rines de aluminio pulido bitono",
                  "Pantalla de 9''",
                  "Paletas de cambio al volante para CVT",
                  "Aire acondicionado automático",
                  "Espejos laterales plegables eléctricamente"
                ]
              },
            ]
          },
        ]
      },
    ],
  },
};

export default info;